import { render, staticRenderFns } from "./CollaboratorAddForm.vue?vue&type=template&id=36e9eab6&scoped=true"
import script from "./CollaboratorAddForm.vue?vue&type=script&lang=js"
export * from "./CollaboratorAddForm.vue?vue&type=script&lang=js"
import style0 from "./CollaboratorAddForm.vue?vue&type=style&index=0&id=36e9eab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e9eab6",
  null
  
)

export default component.exports